import { AppStore } from '../services/';
import { createContext, useContext } from 'react';

import { RedocRawOptions } from '../services/RedocNormalizedOptions';

export interface StoreBuilderProps {
    specUrl?: string;
    spec?: object;
    store?: AppStore;

    options?: RedocRawOptions;

    onLoaded?: (e?: Error) => void;

    children: (props: { loading: boolean; store: AppStore | null }) => any;
}

export interface StoreBuilderState {
    error?: Error;
    loading: boolean;
    resolvedSpec?: any;
    prevSpec?: any;
    prevSpecUrl?: string;
}

const StoreContext = createContext<AppStore | undefined>(undefined);
const { Provider, Consumer } = StoreContext;
export { Provider as StoreProvider, Consumer as StoreConsumer, StoreContext };

export function StoreBuilder() {}

export function useStore(): AppStore | undefined {
    return useContext(StoreContext);
}
